var _path, _path2, _linearGradient, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-49 141 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M112.1 370.3zM302.1 371.5c-.6-.7-1.1-1.3-1.7-1.8.6.5 1.2 1.1 1.7 1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M406.8 261H9.2C-.8 261-9 268.6-9 278v316c0 9.9 8.7 19 18.2 19h397.6c8.9 0 16.2-8.5 16.2-19V278c0-10-6.7-17-16.2-17zm-267 230.5c8.7 6.8 10.3 19.3 3.5 28.1-3.9 5.1-9.8 7.7-15.8 7.7-4.3 0-8.6-1.4-12.3-4.2L31 457.7c-5.6-4.4-8.8-11.1-8.5-18.1.3-6.9 3.9-13.4 9.8-17.3 44.3-29.1 76.8-50.8 82.1-54.6 3.5-3 8-4.8 13-4.8 11 0 20 9 20 20 0 10.6-7.3 15.7-11.7 18.7-2 1.4-4.8 3.3-8.5 5.8-6.2 4.2-15 10-26 17.3-8.7 5.8-17.7 11.8-25.7 17l64.3 49.8zm110.6-135.4-50.2 187.5c-2.4 8.9-10.5 14.8-19.3 14.8-1.7 0-3.5-.2-5.2-.7-10.7-2.9-17-13.8-14.1-24.5l50.2-187.5c2.9-10.7 13.8-17 24.5-14.1 10.6 2.8 16.9 13.8 14.1 24.5zm132.7 102.8-84.2 65.4c-3.6 2.8-8 4.2-12.3 4.2-6 0-11.9-2.7-15.8-7.7-6.8-8.7-5.2-21.3 3.5-28.1l64.1-49.8c-7.9-5.2-17-11.2-25.7-17-11-7.3-19.8-13.2-26-17.3-3.7-2.5-6.5-4.4-8.5-5.8-4.4-3-11.7-8.1-11.7-18.7 0-11 9-20 20-20 5 0 9.5 1.8 13 4.8 5.3 3.9 37.9 25.5 82.1 54.6 5.9 3.9 9.6 10.3 9.8 17.3.5 7-2.7 13.8-8.3 18.1z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -30,
    x2: 456,
    y1: 437,
    y2: 437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff884b svgShape",
    offset: 0,
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff634c svgShape",
    offset: 0.35,
    stopColor: "#fbbc05"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4a4f svgShape",
    offset: 0.655,
    stopColor: "#34a853"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4840 svgShape",
    offset: 1,
    stopColor: "#ea4335"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M406.8 221H9.2c-32.1 0-58.2 25.6-58.2 57v316c0 32 26.7 59 58.2 59h397.6c31 0 56.2-26.5 56.2-59V278c0-32-24.7-57-56.2-57zM423 594c0 10.5-7.3 19-16.2 19H9.2C-.3 613-9 603.9-9 594V278c0-9.4 8.2-17 18.2-17h397.6c9.5 0 16.2 7 16.2 17v316z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -30,
    x2: 456,
    y1: 445.1,
    y2: 445.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff884b svgShape",
    offset: 0,
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff634c svgShape",
    offset: 0.35,
    stopColor: "#fbbc05"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4a4f svgShape",
    offset: 0.655,
    stopColor: "#34a853"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4840 svgShape",
    offset: 1,
    stopColor: "#ea4335"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M127.4 407.4c3.7-2.5 6.5-4.4 8.5-5.8 4.4-3 11.7-8.1 11.7-18.7 0-11-9-20-20-20-5 0-9.5 1.8-13 4.8-5.3 3.9-37.9 25.5-82.1 54.6-5.9 3.9-9.6 10.3-9.8 17.3-.3 7 2.9 13.7 8.5 18.1l84.2 65.4c3.6 2.8 8 4.2 12.3 4.2 6 0 11.9-2.7 15.8-7.7 6.8-8.7 5.2-21.3-3.5-28.1l-64.1-49.8c7.9-5.2 17-11.2 25.7-17 10.9-7.2 19.6-13.1 25.8-17.3zm-13.6-38.9c-.6.6-1.2 1.2-1.7 1.8.5-.7 1.1-1.3 1.7-1.8z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -30,
    x2: 456,
    y1: 446.4,
    y2: 446.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff884b svgShape",
    offset: 0,
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff634c svgShape",
    offset: 0.35,
    stopColor: "#fbbc05"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4a4f svgShape",
    offset: 0.655,
    stopColor: "#34a853"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4840 svgShape",
    offset: 1,
    stopColor: "#ea4335"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M381.8 423.6c-44.3-29.1-76.8-50.8-82.1-54.6-3.5-3-8-4.8-13-4.8-11 0-20 9-20 20 0 10.6 7.3 15.7 11.7 18.7 2 1.4 4.8 3.3 8.5 5.8 6.2 4.2 15 10 26 17.3 8.7 5.8 17.7 11.8 25.7 17l-64.1 49.8c-8.7 6.8-10.3 19.3-3.5 28.1 3.9 5.1 9.8 7.7 15.8 7.7 4.3 0 8.6-1.4 12.3-4.2l84.2-65.4c5.6-4.4 8.8-11.1 8.5-18.1-.5-7-4.2-13.5-10-17.3zm-81.4-54c.6.5 1.1 1.2 1.7 1.8-.5-.6-1.1-1.2-1.7-1.8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -30,
    x2: 456,
    y1: 444.651,
    y2: 444.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff884b svgShape",
    offset: 0,
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorff634c svgShape",
    offset: 0.35,
    stopColor: "#fbbc05"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4a4f svgShape",
    offset: 0.655,
    stopColor: "#34a853"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stopColorfe4840 svgShape",
    offset: 1,
    stopColor: "#ea4335"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M236.2 331.6c-10.7-2.9-21.6 3.5-24.5 14.1l-50.2 187.5c-2.9 10.7 3.5 21.6 14.1 24.5 1.7.5 3.5.7 5.2.7 8.8 0 16.9-5.9 19.3-14.8l50.2-187.5c2.9-10.7-3.4-21.7-14.1-24.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.c2006bc2ecf8815c2dc986096ecdd7af.svg";
export { ForwardRef as ReactComponent };